<template>
    <div>
        <base-modal id="modalContactNotification" :fullscreen="true">
            <div class="modal-header"></div>
            <div class="modal-body">
                <user-picture :size="'-xlarge'" :border="'-border-white'" :user="user" v-if="userStatus" />

                <p>
                    <span class="color-alt" v-if="notiStatus">{{ notification.name }}</span
                    >, já recebi os dados e em breve entrarei em contato com você por
                    <span class="color-contrast" v-if="notiStatus">{{ notification.notificationType }}.</span>
                </p>

                <slot />

                <p>Se você desejar falar comigo rapidamente meu telefone é:</p>

                <p class="phone" v-if="userStatus">{{ user.phone }}</p>

                <button class="button -xlarge -contrast" @click="close" type="button">
                    Voltar para o site
                </button>
            </div>
        </base-modal>
    </div>
</template>

<script>
    import BaseModal from '@/Components/BaseModal'
    import UserPicture from '@/Components/User/UserPicture'

    export default {
        components: {
            BaseModal,
            UserPicture,
        },

        props: {
            user: {
                type: Object,
                require: true,
                default() {
                    return {}
                },
            },
        },

        data() {
            return {
                notification: null,
                notiStatus: false,
                userStatus: false,
            }
        },

        computed: {
        },

        methods: {
            close() {
                this.$root.$emit('hideModal', 'modalContactNotification')
            },
        },

        mounted() {
            this.$root.$on('notification', (payload) => {
                if (payload) {
                    this.notification = payload
                }
            })
        },

        watch: {
            notification: function(newValue) {
                this.notiStatus = Object.keys(newValue).length !== 0
            },

            user: function(newValue) {
                this.userStatus = Object.keys(newValue).length !== 0
            },
        },
    }
</script>

<style lang="stylus" scoped></style>
